module.exports = __webpack_public_path__ + "statics/img/1.ec6da2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/1.jpg
// module id = +bnB
// module chunks = 1